/* eslint-disable react/no-danger */
/** @jsx jsx */
import { jsx, Box, Container } from 'theme-ui';
import React, { FunctionComponent } from 'react';

// Types
import { PostDetails } from '../../@codersclan/gatsby-theme-airfleet/@types/post';

// Components
import Text, { TEXT_TYPES } from '../text';
import TextFrame from '../textFrame';
import HeroV3WithForm from '../heroV3WithForm';
import HeroV3WithText from '../heroV3WithText';
import Share from '../share';

// Styles
import { baseStyle } from './style';
import SideBySideTextImage from '../sideBySideTextImage';

interface PostAssetProps {
  post: PostDetails;
  gated?: boolean;
}
const PostAsset: FunctionComponent<PostAssetProps> = React.memo(
  ({ post, gated }) => {
    const { guAssetsSections } = post.templateGatedUngatedAsset || {};

    return (
      <Container sx={baseStyle.mainContainer}>
        {gated ? (
          <HeroV3WithForm
            title={post.title}
            image={post.featuredImage?.node}
            customForm={post.sectionWebinar?.webinarOptions?.customForm}
            pardotUrl={guAssetsSections?.pardotEmbedUrl}
            sx={baseStyle.heroWithForm}
            sameSizeCol
          />
        ) : (
          <HeroV3WithText
            title={post.title}
            content={post.content}
            image={post.featuredImage?.node}
            cta={{
              label: guAssetsSections?.assetDownloadLabel || '',
              url: guAssetsSections?.assetDownloadUrl,
              pageSelector: guAssetsSections?.assetDownloadPageSelector,
              target: guAssetsSections?.assetDownloadTarget || '_self',
            }}
            sx={baseStyle.heroWithText}
            sameSizeCol
          />
        )}

        {gated && (
          <Box>
            {/* Section Webinar Description */}
            <Box sx={baseStyle.content}>
              {/* <Text type={TEXT_TYPES.H2} sx={baseStyle.contentTitle}>
                {post.title}
              </Text> */}
              <TextFrame content={post.content} sx={baseStyle.contentBody} />
            </Box>

            {/* Section Middle Content */}
            {(guAssetsSections?.rowsSection?.length ?? []) > 0 && (
              <Box sx={baseStyle.middleContent}>
                {guAssetsSections?.rowsSection?.map((section, idx) => (
                  <SideBySideTextImage
                    key={`section_${idx}`}
                    imageOnLeft={
                      section.assetRowChooseTheImageSide.side === 'left'
                    }
                    title={section.assetRowTitle.title}
                    content={section.assetRowText.content}
                    imageDesktop={section.assetRowImage.image}
                    imageMobile={section.assetRowMobile.mobileImage}
                    sx={baseStyle.sideBySide}
                  />
                ))}
              </Box>
            )}
          </Box>
        )}

        {/* Section: Share */}
        <Share sx={baseStyle.share} />
      </Container>
    );
  },
);

export default PostAsset;
